import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HelpService from "../../Controller/Configuration/HelpLinkController";
import { handleChange, handleSubmit } from "../../Controller/Configuration/CreateHelpLinkController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function HelpLinkPage() {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
   
    const [formData, setFormData] = useState({ ID: 0, Link: '' });
    const [errors, setErrors] = useState({});
    const [isSaved, setIsSaved] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.get('saved') === 'true') {
            setIsSaved(true);
            setTimeout(() => {
                setIsSaved(false); // Hide the alert after 2 seconds
            }, 2000);
        }
    }, [location]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const fetchHelpLink = async () => {
        try {
            const data = await HelpService.GetAllHelpLinks(() => navigate('/')); // Redirect to the login page on error
            setFormData({ ID: data[0].ID, Link: data[0].HelpLink });
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        fetchHelpLink();
    }, []);

    const handleFormSubmit = (event) => {
        event.preventDefault();
        handleSubmit(event, formData, setFormData, setErrors, () => {
            navigate(`/Configuration?saved=true`);
        }, () => {
            navigate(`/Configuration?saved=true`);
        });
    };
    const handleThemeChange = (e) => {
        const selectedTheme = e.target.value;
        if (selectedTheme !== theme) {
            toggleTheme();
            // document.body.classList.remove(theme);
            // document.body.classList.add(selectedTheme);
        }
    };
    return (
        <div>
            <nav class="navbar navbar-expand fixed-top top-menu">
                <ul class="main-links">
                    <li>
                        
                    </li>
                </ul>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">

                    <ul class="navbar-nav right-nav ml-auto">
                        <li class="nav-item dropdown message-box d-none d-sm-block">
                            <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div class="count-info">
                                    <i class="lni lni-world"></i> EN
                                </div>
                            </a>

                            <div class="dropdown-menu">
                                <a class="dropdown-item" href="javascript:void(0);">
                                    <div class="message-item">
                                        <div class="chat-content">
                                            <span class="message-title">English</span>
                                        </div>
                                    </div>
                                </a>
                                <a class="dropdown-item" href="javascript:void(0);">
                                    <div class="message-item">
                                        <div class="chat-content">
                                            <span class="message-title">French</span>
                                        </div>
                                    </div>
                                </a>
                                <a class="dropdown-item" href="javascript:void(0);">
                                    <div class="message-item">
                                        <div class="chat-content">
                                            <span class="message-title">German</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </li>
                        <li className="nav-item">
                            <select id="ddlTheme" style={{ marginTop: "8px", height: "34px" }} className="form-control" value={theme} onChange={handleThemeChange}>
                                <option value="light">Light Theme</option>
                                <option value="dark">Dark Theme</option>
                            </select>
                        </li>


                        <li class="nav-item dropdown profile-nav-item">
                            <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div class="menu-profile">
                                    <img src="assets/img/profile.png" alt="Profile Image" class="rounded-circle" />
                                    <span class="name">Admin</span>
                                </div>
                            </a>

                            <div class="dropdown-menu">
                                <a class="dropdown-item" href="profile.html">
                                    <i data-feather="user" class="icon"></i>
                                    Profile
                                </a>





                                <Link class="dropdown-item" to="/">
                                    <i data-feather="log-out" class="icon"></i>
                                    Logout
                                </Link>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
            <div className="main-content-header">
                <h1>Configuration</h1>
            </div>
            <form onSubmit={handleFormSubmit}>

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card mb-30">
                            <div className="card-body">

                                <div className="table-responsive">
                                    {isSaved && <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        Data saved successfully!
                                    </div>}
                                    <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                        <label htmlFor="inputText" className="col-sm-2 col-form-label">Help Site: <span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input type="text" className='form-control' name="Link" value={formData.Link} onChange={handleFieldChange} />
                                            {errors.Link && <div style={{ color: 'red' }}>{errors.Link}</div>}
                                        </div>
                                    </div>
                                    <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-4">
                                            <button type="submit" className="btn btn-outline-success mt-3">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>







            </form>
        </div>
    );
}

export default HelpLinkPage;
